import React, { PureComponent } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import SelectInput from './SelectInput';
import { BIRTH_SEX_MALE, BIRTH_SEX_FEMALE, BIRTH_SEX_OTHER } from '../../constants/index';

type Props = {
  s?: any;
  id?: string;
  field?: any;
  values?: any[];
  trackEvent?: string;
  hasDefault?: boolean;
  showErrors?: boolean;
  errorInLine?: boolean;
  funPlaceholder?: boolean;
  placeholder?: string;
  submitted?: boolean;
  validateField?: (...args: any[]) => any;
  inputProps?: any;
  t: TFunction<'common'>;
};

class PatientSexSelectInput extends PureComponent<Props> {
  render = () => {
    const { t } = this.props;

    const options = [
      {
        key: BIRTH_SEX_MALE.toLowerCase(),
        label: t('userInfo.sexMale'),
        value: BIRTH_SEX_MALE.toLowerCase(),
      },
      {
        key: BIRTH_SEX_FEMALE.toLowerCase(),
        label: t('userInfo.sexFemale'),
        value: BIRTH_SEX_FEMALE.toLowerCase(),
      },
      {
        key: BIRTH_SEX_OTHER.toLowerCase(),
        label: t('userInfo.sexOther'),
        value: BIRTH_SEX_OTHER.toLowerCase(),
      },
    ];

    return (
      <SelectInput
        defaultValue={this.props.placeholder}
        errorInline={this.props.errorInLine}
        field={this.props.field}
        funPlaceholder={this.props.funPlaceholder}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'string... Remove this comment to see the full error message
        id={this.props.id}
        inputProps={{ 'aria-label': this.props.placeholder, ...this.props.inputProps }}
        placeholder={this.props.placeholder}
        s={this.props.s}
        showErrors={this.props.showErrors}
        submitted={this.props.submitted}
        trackEvent={this.props.trackEvent}
        validateField={this.props.validateField}
        values={options}
      />
    );
  };
}

export default withTranslation()(PatientSexSelectInput);
